var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0051 1.66732C14.6064 1.67192 18.3331 5.40492 18.3301 10.0062C18.327 14.6075 14.5953 18.3355 9.99397 18.334C5.39268 18.3325 1.66341 14.6019 1.66341 10.0007C1.66617 5.39617 5.40059 1.66548 10.0051 1.66732ZM16.6634 9.85732C16.624 6.18962 13.6292 3.2427 9.96129 3.26232C6.29344 3.28213 3.33046 6.26108 3.33046 9.92899C3.33046 13.5969 6.29344 16.5758 9.96129 16.5957C13.6292 16.6153 16.624 13.6684 16.6634 10.0007V9.85732ZM9.16341 5.83399H10.8301L10.8301 7.50066H9.16341V5.83399ZM9.16341 9.16732H10.8301V14.1673H9.16341L9.16341 9.16732Z",
    fill: "#313544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionIcon);
export default __webpack_public_path__ + "static/media/attention_icon.fd649f50832a87c31dc6b3bddb5c8629.svg";
export { ForwardRef as ReactComponent };